import type { ReactNode } from "react";
import type { MetaEtapa } from "../tipos";

/**
 * Caja de una etapa numerada del brief: borde, número, nombre y a la derecha
 * quién la produjo. Si `meta.prompt_version` existe se muestra en gris
 * chiquito — es lo que después permite atribuir una pieza mala a un cambio
 * de prompt. Si `meta.estado === "editado_por_usuario"`, una píldora que lo
 * dice.
 *
 * El contenido de cada etapa (distinto por etapa) va como `children` — ver
 * `ContenidoEtapasBrief.tsx`. La sección "Copy de canal" de `PiezaPage.tsx`
 * no usa esta caja: es "sin número" a propósito (`CopyDeCanal.tsx`).
 */

interface EtapaBriefProps {
  numero: number;
  titulo: string;
  agente: string;
  meta: MetaEtapa;
  children: ReactNode;
}

export const EtapaBrief = ({ numero, titulo, agente, meta, children }: EtapaBriefProps) => (
  <section className="rounded-2xl border border-[#E2E4EA] bg-white p-6">
    <header className="flex flex-wrap items-start justify-between gap-3">
      <div className="flex items-center gap-3">
        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[rgb(var(--brand-primary-rgb)_/_0.08)] text-[12px] font-semibold text-brand-primary">
          {numero}
        </span>
        <div>
          <div className="flex flex-wrap items-center gap-2">
            <h2 className="text-[15px] font-semibold text-brand-black">{titulo}</h2>
            {meta.estado === "editado_por_usuario" && (
              <span className="rounded-full bg-[#F7EBD5] py-1 px-2.5 text-[11px] font-medium text-[#8A5A08]">
                Editado por usuario
              </span>
            )}
          </div>
          {meta.prompt_version && (
            <p className="mt-0.5 text-[11px] text-[rgb(var(--brand-black-rgb)_/_0.4)]">prompt {meta.prompt_version}</p>
          )}
        </div>
      </div>
      <span className="shrink-0 text-[12px] text-[rgb(var(--brand-black-rgb)_/_0.55)]">{agente}</span>
    </header>

    <div className="mt-4">{children}</div>
  </section>
);

export default EtapaBrief;
